import { useContext, useEffect, useMemo, useState } from "react"
import { Context } from "../../../.."
import { useModal } from "../../../../hooks/useModal"
import { useAddresses, useDeleteAddress } from "../../../../http/addressApi"
import AddressModal from "../../../Shipping/AddressModal"
import AddressAdd from "./AddressAdd"
import DeleteAddress from "./DeleteAddress"


const AddressItem = ({
    data,
    onDeleteAddress
}) => {
    const { delivery } = useContext(Context)
    const { isModalOpen, openModal, closeModal } = useModal();

    const PICKUP_NAME = useMemo(() => {
        switch (data.pickupType) {
            case 'cdek':
                return 'СДЭК'

            case 'yandex':
                return 'Яндекс'
        }
    }, [data])

    const handleChangePickup  = (id) => {
        delivery.setEditDataPickup(id)
    }

    const handleChangeDelivery = () => {
        delivery.setCityInfo(data.addressFields?.cityInfo);
        delivery.setEditDataDelivery(data)
    }

    const handleEdit = (id) => {
        if (data.type === 'pickup') {
            handleChangePickup(id)
        }

        if (data.type === 'courier') {
            handleChangeDelivery()
        }

        openModal()
    }

    return <>
        <div className="address-item">
            <div className="address-item__info">
                {data.type === 'courier' ? (
                    <h3 className="address-item__title">{data.addressFields.all.value}{data.addressFields?.apartment ? `, кв. ${data.addressFields?.apartment}` : ''} </h3>
                ) : (
                    <h3 className="address-item__title">{PICKUP_NAME}, {data.addressFields.street}</h3>
                )}
                {data.type === 'courier' && <span className="address-item__desc">{data.addressFields.comment}</span>}
                {data.type === 'pickup' && data.addressFields.work_time && <span className="address-item__work-time">{data.addressFields.work_time }</span>}
            </div>

            <div className="address-item__group">
                <button className="address-item__action" type="button" onClick={() => {
                    handleEdit(data.id)
                }}>
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M14.0517 3.73916L15.4575 2.33249C15.7506 2.03943 16.148 1.87479 16.5625 1.87479C16.977 1.87479 17.3744 2.03943 17.6675 2.33249C17.9606 2.62556 18.1252 3.02304 18.1252 3.43749C18.1252 3.85195 17.9606 4.24943 17.6675 4.54249L8.81833 13.3917C8.37777 13.832 7.83447 14.1556 7.2375 14.3333L5 15L5.66667 12.7625C5.8444 12.1655 6.16803 11.6222 6.60833 11.1817L14.0517 3.73916ZM14.0517 3.73916L16.25 5.93749M15 11.6667V15.625C15 16.1223 14.8025 16.5992 14.4508 16.9508C14.0992 17.3024 13.6223 17.5 13.125 17.5H4.375C3.87772 17.5 3.40081 17.3024 3.04917 16.9508C2.69754 16.5992 2.5 16.1223 2.5 15.625V6.87499C2.5 6.37771 2.69754 5.9008 3.04917 5.54917C3.40081 5.19754 3.87772 4.99999 4.375 4.99999H8.33333" stroke="#1A1A1A" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                </button>
                <button className="address-item__action" type="button" onClick={() => onDeleteAddress(data)}>
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12.2833 7.50001L11.995 15M8.005 15L7.71667 7.50001M16.0233 4.82501C16.3083 4.86834 16.5917 4.91417 16.875 4.96334M16.0233 4.82501L15.1333 16.3942C15.097 16.8652 14.8842 17.3051 14.5375 17.626C14.1908 17.9469 13.7358 18.1251 13.2633 18.125H6.73667C6.26425 18.1251 5.80919 17.9469 5.46248 17.626C5.11578 17.3051 4.90299 16.8652 4.86667 16.3942L3.97667 4.82501M16.0233 4.82501C15.0616 4.6796 14.0948 4.56925 13.125 4.49417M3.97667 4.82501C3.69167 4.86751 3.40833 4.91334 3.125 4.96251M3.97667 4.82501C4.93844 4.67961 5.9052 4.56926 6.875 4.49417M13.125 4.49417V3.73084C13.125 2.74751 12.3667 1.92751 11.3833 1.89667C10.4613 1.86721 9.53865 1.86721 8.61667 1.89667C7.63333 1.92751 6.875 2.74834 6.875 3.73084V4.49417M13.125 4.49417C11.0448 4.33341 8.95523 4.33341 6.875 4.49417" stroke="#1A1A1A" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                </button>
            </div>
        </div>

        {isModalOpen && <AddressModal 
            isModalOpen={isModalOpen} 
            closeModal={closeModal}
        />}
    </>
}

export default function AddressesList() {
    const {isModalOpen, openModal, closeModal} = useModal()
    const {delivery} = useContext(Context)
    const [deleteAddress, setDeleteAddress] = useState(null)
    const deleteAddressMutation = useDeleteAddress()
    const {data} = useAddresses()

    const handleDeleteAddress = () => {
        const {id} = deleteAddress
        closeModal()
      }

    useEffect(() => {
        if (deleteAddress) {
            openModal()
        }
    }, [deleteAddress])

    useEffect(() => {
        if (!isModalOpen) {
            setDeleteAddress(null)
        }
    }, [isModalOpen])


    return <div className="addresses-list">
        {data && data.rows.map((item) => {
            return <AddressItem key={item.id} data={item} onDeleteAddress={(id) => {
                setDeleteAddress(id)
            }}/>
        })}

        <AddressAdd />
        <DeleteAddress isModalOpen={isModalOpen} closeModal={closeModal} address={deleteAddress} onDelete={handleDeleteAddress}  />
    </div>
}